import NumberFormat from 'react-number-format'
import styled from 'styled-components/macro'

export const SectionBarner = styled.div<{ isMobile?: boolean }>`
  display: flex;
  width: ${({ isMobile }) => (isMobile ? '100%' : '80%')};
  justify-content: center;
  align-items: center;
  flex-direction: row;
  margin-top: 20px;
`

export const SectionTypesSports = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  margin-top: 10px;
  width: 100%;
`
export const SectionListSports = styled.div`
  display: flex;
  width: 100%;
  align-content: center;
  align-items: center;
  justify-content: center;
`
export const BarnerItem = styled.div`
  height: 150px;
  align-content: center;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 5px;
`

export const FilterBadge = styled.div<{ isSelected?: boolean }>`
  padding: 5px;
  margin: 5px;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 5px;
  background-color: ${({ theme, isSelected }) => (isSelected ? theme.primary1 : theme.primary4)};
  cursor: pointer;
`

export const FilterBadgeImg = styled.img`
  height: 20px;
  margin-right: 4px;
`

export const FilterContainer = styled.div`
  width: 100%;
  margin-top: 10px;
`

export const FilterContainerItem = styled.div<{ isMobile?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: ${({ isMobile }) => (isMobile ? 'center' : 'left')};
  width: 100%;
  gap: 0.5rem;
`

export const FilterContainerItemBadge = styled.div<{ isSelected?: boolean }>`
  padding: 10px;
  min-height: 50px;
  margin: 5px;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 5px;
  font-size: 13px;
  background-color: ${({ theme, isSelected }) => (isSelected ? theme.primary1 : theme.primary5)};
  cursor: pointer;
`

export const FilterContainerFinishBadge = styled.div<{ isSelected?: boolean; isMobile?: boolean }>`
  width: ${({ isMobile }) => (isMobile ? '' : '30%')};
  padding: 10px;
  min-height: 50px;
  margin: 5px;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 5px;
  font-size: 13px;
  background-color: ${({ theme, isSelected }) => (isSelected ? theme.primary1 : theme.primary5)};
  cursor: pointer;
`

export const CurrentEventsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 10px;
  width: 100%;
`

export const CurrentEventsItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 10px;
  width: 100%;
  background-color: ${({ theme }) => theme.bg2};
`

export const CurrentEventsItemStatus = styled.div`
  background: #08adff;
  width: 100%;
  text-align: center;
`

export const CurrentEventsItemTeams = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 50%;
  font-size: 13px;
  background-color: ${({ theme }) => theme.bg2};
`

export const CurrentEventsItemTeamsTitle = styled.div`
  text-align: 'center';
`
export const CurrentEventsItemTeamsRatio = styled.div`
  text-align: 'center';
`
export const CurrentEventsItemTeamsBet = styled.div`
  text-align: 'center';
`
export const CurrentEventsItemTeamsLine = styled.div`
  width: 2px;
  height: auto;
  background: #333;
`
export const CurrentEventsTrends = styled.div`
  width: 100%;
  height: auto;
  border: 0.1rem solid #ffe619;
  margin: 10px;
  border-radius: 5px;
  text-align: left;
  font-size: 1rem;
  text-vertical-align: middle;
  border-color: #ffe619;
  box-shadow: 0 0 0.1rem #fff, 0 0 0.1rem #fff, 0 0 0.5rem #fffb00, 0 0 0.5rem #fffb00, 0 0 0.1rem #fffb00,
    inset 0 0 0.1rem #fffb00;
  padding: 5px;
  padding-left: 30px;
  margin-bottom: 30px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 95%;
    margin-left: 2.5%;
  `};
`

export const CurrentEventsEventsTitle = styled.div`
  width: 100%;
  height: auto;
  border: 0.1rem solid #bc13fe;
  margin: 10px;
  border-radius: 5px;
  text-align: left;
  font-size: 1rem;
  text-vertical-align: middle;
  border-color: #bc13fe;
  box-shadow: 0 0 0.1rem #fff, 0 0 0.1rem #fff, 0 0 0.5rem #bc13fe, 0 0 0.5rem #bc13fe, 0 0 0.1rem #bc13fe,
    inset 0 0 0.1rem #bc13fe;
  padding: 5px;
  padding-left: 30px;
  margin-top: 30px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 95%;
    margin-left: 2.5%;
  `};
`

export const CurrentEventsMyBetsTitle = styled.div`
  width: 100%;
  height: auto;
  border: 0.1rem solid #7af3ff;
  margin: 10px;
  border-radius: 5px;
  text-align: left;
  font-size: 1rem;
  text-vertical-align: middle;
  border-color: #7af3ff;
  box-shadow: 0 0 0.1rem #fff, 0 0 0.1rem #fff, 0 0 0.5rem #7af3ff, 0 0 0.5rem #7af3ff, 0 0 0.1rem #7af3ff,
    inset 0 0 0.1rem #7af3ff;
  padding: 5px;
  padding-left: 30px;
  margin-bottom: 30px;
  margin-top: 30px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 95%;
    margin-left: 2.5%;
  `};
`

export const CurrentEventsBetsTable = styled.div`
  width: 100%;
  height: auto;
  border: 0.1rem solid #32ec9e;
  margin: 10px;
  border-radius: 5px;
  text-align: left;
  font-size: 1rem;
  text-vertical-align: middle;
  border-color: #32ec9e;
  box-shadow: 0 0 0.1rem #fff, 0 0 0.1rem #fff, 0 0 0.5rem #32ec9e, 0 0 0.5rem #32ec9e, 0 0 0.1rem #32ec9e,
    inset 0 0 0.1rem #32ec9e;
  padding: 5px;
  padding-left: 30px;
  margin-bottom: 30px;
  margin-top: 30px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 95%;
    margin-left: 2.5%;
    font-size: 0.8rem;
  `};
`

export const CurrentEventsTrendContainer = styled.div`
  width: 100%;
  height: auto;
  border: 0.1rem solid #7af3ff;
  margin: 10px;
  border-radius: 5px;
  text-align: center;
  font-size: 1rem;
  text-vertical-align: middle;
  border-color: #7af3ff;
  box-shadow: 0 0 0.1rem #fff, 0 0 0.1rem #fff, 0 0 0.5rem #7af3ff, 0 0 0.5rem #7af3ff, 0 0 0.1rem #7af3ff,
    inset 0 0 0.1rem #7af3ff;
  display: flex;
  align-items: center;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: column;
    width: 95%;
    margin: 2.5%;
  `};
`

export const CurrentEventsTrendContainerItem = styled.div`
  width: 100%;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 100%;
  `};
`

export const CurrentEventsTrendContainerItemTeamsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px;
`

export const CurrentEventsTrendContainerItemTeamsContainerTeam = styled.div`
  font-size: 14px;
  width: 50%;
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 100%;
  `};
  justify-content: space-between;
  align-items: center;
  margin: 10px;
  border-color: #7af3ff;
  box-shadow: 0 0 0.1rem #fff, 0 0 0.1rem #fff, 0 0 0.5rem #7af3ff, 0 0 0.5rem #7af3ff, 0 0 0.1rem #7af3ff,
    inset 0 0 0.1rem #7af3ff;
  display: flex;
  border: 0.1rem solid #7af3ff;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 5px;
`

export const BetModalContainerItemTeamsContainerTeam = styled.div`
  font-size: 14px;
  width: 50%;
  display: flex;
  text-align: center;
  flex-direction: column;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 100%;
  `};
  justify-content: space-between;
  align-items: center;
  margin: 10px;
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 5px;
`

export const CurrentEventsTrendContainerItemTeamsContainerTeams = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: column;
  `};
  justify-content: space-between;
`

export const CurrentEventsButtonBet = styled.div`
  font-size: 12px;
  border: 1px solid ${({ theme }) => theme.primary1};
  border-radius: 8px;
  padding-left: 15px;
  padding-right: 15px;
  margin: 2px;
  cursor: pointer;
  &:hover {
    background: ${({ theme }) => theme.primary1};
  }
`

export const CurrentEventsButtonBetClosed = styled.div`
  font-size: 12px;
  border: 1px solid red;
  border-radius: 8px;
  padding-left: 15px;
  padding-right: 15px;
  margin: 2px;
  cursor: pointer;
  &:hover {
    background: red;
  }
`

export const TableResultsButtonRatio = styled.div`
  background: rgb(255, 203, 0) none repeat scroll 0% 0%;
  color: rgb(51, 51, 51);
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px;
  cursor: pointer;
  font-size: 13px;
  &:hover {
    background: rgb(255, 224, 105) none repeat scroll 0% 0%;
  }
`
export const TableResultsButtonRatioDisabled = styled.div`
  background: #bfbfbf;
  color: #333;
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px;
  font-size: 13px;
`

export const ModalBetInputNumber = styled(NumberFormat)`
  background-color: transparent;
  margin-top: 1rem;
  border: 1px solid ${({ theme }) => theme.primary1};
  border-radius: 5px;
  padding: 5px;
  color: ${({ color, theme }) => color || theme.text1};
`
